import React, { FC } from "react";
import "./InformTable.scss";

import "./InformPanel.scss";

export interface InformTableDataRow {
    property: string;
    value: string | string[];
}

interface InformTableProps {
    data: InformTableDataRow[];
    label?: string;
}

export const prepareInformTableData = (
    rawData: Array<{ property: string; value: any }>
): InformTableDataRow[] => {
    return rawData
        .filter(
            (row) =>
                row.value !== null &&
                row.value !== undefined &&
                row.value !== "null"
        )
        .map((row) => ({
            property: row.property,
            value: Array.isArray(row.value)
                ? row.value.map((item) => item.toString())
                : row.value.toString(),
        }));
};

const InformTable: React.FC<InformTableProps> = ({ data, label }) => {
    return (
        <div className="comparison-card">
            <div className="comparison-card__title">{label}</div>

            <table className="comparison-table">
                <tbody>
                    {data.map((row, index) => (
                        <tr key={index}>
                            <td className="auto-width">{row.property}:</td>
                            <td>
                                {Array.isArray(row.value) ? (
                                    <div className="list_tag">
                                        {row.value.map((item, idx) => (
                                            <span key={idx} className="tag">
                                                {item}
                                            </span>
                                        ))}
                                    </div>
                                ) : (
                                    row.value
                                )}
                            </td>
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    );
};

export default InformTable;
